import * as cheerio from "cheerio";

import { DYCE_PLATFORM } from "../enums/exports";

export type PlatformConfig = {
    head?: { add?: string[]; replace?: { selector: string; value: string }[] };
    body?: { add: string[] };
    custom?: ($: cheerio.CheerioAPI) => void;
};

function getScriptVersion(source: string) {
    return /(\d{1,3}\.\d{1,3}\.\d{1,3})/.exec(source)?.[0];
}

export function replaceGsapScriptWithSameVersion($: cheerio.CheerioAPI, newScript: string, defaultVersion: string) {
    const scripts = $('script[src*="gsap"]').toArray();

    if (scripts.length) {
        scripts.forEach((script) => {
            const src = $(script).attr("src") ?? "";

            const version = getScriptVersion(src);
            let replaceVersion = defaultVersion;

            if (version && parseInt(version.split(".")[0]) > 2) {
                replaceVersion = version;
            }

            const replaceScript = newScript.replace("[VERSION]", replaceVersion);

            $(script).replaceWith(replaceScript);
        });
    } else {
        $("head").append(newScript.replace("[VERSION]", defaultVersion));
    }
}

const doubleclick = {
    head: {
        add: ['<script type="text/javascript" src="https://s0.2mdn.net/ads/studio/Enabler.js"></script>'],
        replace: [
            {
                selector: 'meta[name="ad.size"]',
                value: '<meta name="ad.size" content="width=@width,height=@height">',
            },
        ],
    },
};

const doubleclick_sv = {
    head: {
        add: ['<script src="https://s0.2mdn.net/ads/studio/Enabler.js"></script>'],
        replace: [
            {
                selector: 'meta[name="ad.size"]',
                value: '<meta name="ad.size" content="width=@width,height=@height">',
            },
        ],
    },
    body: {
        add: [
            '<script type="text/javascript">Enabler.setProfileId(@dcProfileId);var dcFeedName = "@dcFeedName"</script>',
        ],
    },
};

const generic = {
    head: {
        add: ['<script type="text/javascript">var clickTag = "http://www.google.com";</script>'],
    },
    custom: ($: cheerio.CheerioAPI) => {
        const newScript =
            '<script type="text/javascript" src="https://cdn.jsdelivr.net/npm/gsap@[VERSION]/dist/gsap.min.js"></script>';
        const defaultVersion = "3.12.5";

        replaceGsapScriptWithSameVersion($, newScript, defaultVersion);
    },
};

const opendc = {};

const flashtalking = {
    body: {
        add: ['<script src="https://cdn.flashtalking.com/frameworks/js/api/2/10/html5API.js"></script>'],
    },
    custom: ($: cheerio.CheerioAPI) => {
        const newScript =
            '<script type="text/javascript" src="https://cdn.flashtalking.com/frameworks/js/gsap/[VERSION]/gsap.min.js"></script>';
        const defaultVersion = "3.12.5";

        replaceGsapScriptWithSameVersion($, newScript, defaultVersion);
    },
};

export const config = Object.seal({
    [DYCE_PLATFORM.DOUBLECLICK]: doubleclick,
    [DYCE_PLATFORM.DOUBLECLICK_SV]: doubleclick_sv,
    [DYCE_PLATFORM.GENERIC]: generic,
    [DYCE_PLATFORM.FLASHTALKING]: flashtalking,
    [DYCE_PLATFORM.OPENDC]: opendc,
    [DYCE_PLATFORM.GENERIC_LITE]: generic,
    [DYCE_PLATFORM.PREVIEW]: {},
});
